import React, { useEffect, useState, useMemo, useRef } from 'react';
import dayjs from 'dayjs';

import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import LoadingButton from '@mui/lab/LoadingButton';
import SearchIcon from '@material-ui/icons/Search';
import Box from '@material-ui/core/Box';

import { GetVibrationSpecialString, SpeedKind } from '../../../Constant';

import { FFTC_CMP_GROUP_SET } from '../../../function/GroupDataModel';
import {
  MeasureInfoType,
  GetMeasureInfoType,
  SelectDataType,
  CreateDefalutMeasureInfoType,
  GetLatesTime,
  CreateDefalutSelectDataType,
  GetAdditionalMeasureInfoType,
  FindMeasureInfoType,
  GetComparisonNo,
  GetDataTimeList,
} from './FFTComparisonConanair';
import FFTComparisonConanairInfo from './FFTComparisonConanairInfo';
import FFTComparisonConanairChartSetting, { RangeSelectDataType } from './FFTComparisonConanairChartSetting';
import FFTComparisonConanairChart, { GraphDispSetting, GraphData, ChartUpDateInfo } from './FFTComparisonConanairChart';
import FFTComparisonConanairButtonList from './FFTComparisonConanairButtonList';
import { SelectItemRefreshData } from './FFTComparisonConanairSelectItem';
import { useTranslation } from 'react-i18next';
import { IsValidKindOfFftCmpConan } from '../../../function/NameDevSetModel';
import { Typography } from '@material-ui/core';
import SimpleDialog from '../../atoms/Dialog/SimpleDialog';
import { GetKindNoNameSetType, KIND_NO_NAME_SET } from '../MeasureSetting/CollectSetting/CollectSettingDefine';
import { ComboBoxItemType } from '../../atoms/ComboBox/ItemComboBox';

const useStyles = makeStyles(
  createStyles({
    responsiveContainer: {
      minHeight: 'calc(100vh - 446px)',
      maxHeight: 'calc(100vh - 446px)',
    },
    paper: {
      background: '#FFFFEE',
    },
    paperChild: {
      background: '#FFFFEE',
    },
    buttonStyle: {
      width: '100px',
      maxHeight: '35px',
      minHeight: '35px',
      marginRight: '4px',
    },
  })
);

const createSelectData = (
  meslist: MeasureInfoType[],
  orgData: SelectDataType,
  indexNo: number,
  target?: MeasureInfoType,
  gp?: FFTC_CMP_GROUP_SET
): SelectDataType => {
  if (target === undefined) {
    return orgData;
  } else {
    //計測種別の書込み
    if (gp !== undefined) {
      if (indexNo === 1) {
        orgData.mesid = gp.SET_NO1;
      } else if (indexNo === 2) {
        orgData.mesid = gp.SET_NO2;
      } else {
        orgData.mesid = gp.SET_NO3;
      }
    }

    var did = meslist.find((row) => row.DevIndex === target.DevIndex);
    // orgData.mesid = did !== undefined ? did.conanSetNo : 0;
    orgData.devid = did !== undefined ? did.id : orgData.devid;

    var iid = meslist.find((row) => row.PlcNo === target.PlcNo);
    orgData.itemid = iid !== undefined ? iid.id : orgData.itemid;

    return orgData;
  }
};

type Props = {
  location: { state: FFTC_CMP_GROUP_SET };
};

const FFTComparisonConanairPage: React.FC<Props> = (props) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [graphData, setGraphData] = useState<GraphData[]>([]);
  const [loading, setLoading] = React.useState(false);
  const [conanFFTComboList, setConanFFTComboList] = useState<ComboBoxItemType[]>([]);

  console.debug(['★★FFTComparisonPage() -- loading', loading, props]);

  const [measureInfo, setMeasereInfo] = React.useState<MeasureInfoType[]>([]);

  const selectData1Ref = React.useRef<SelectDataType>(
    CreateDefalutSelectDataType(t('FFTComparisonConanairPage.計測データ１', '計測データ１'), 'red', 1)
  );
  const selectData2Ref = React.useRef<SelectDataType>(
    CreateDefalutSelectDataType(t('FFTComparisonConanairPage.計測データ２', '計測データ２'), 'blue', 2)
  );
  const selectData3Ref = React.useRef<SelectDataType>(
    CreateDefalutSelectDataType(t('FFTComparisonConanairPage.計測データ３', '計測データ３'), 'green', 3)
  );

  const isFFTAutoRangeRef = React.useRef<boolean>(true);

  const [chartInfo, setChartInfo] = React.useState<ChartUpDateInfo>({
    line1: selectData1Ref.current,
    line2: selectData2Ref.current,
    line3: selectData3Ref.current,
    mesList: measureInfo,
    isInitDisp: true,
  });

  const [selectItemRefreshDatas, setSelectItemRefreshDatas] = React.useState<SelectItemRefreshData[]>([]);

  const [graphDispSetting, SetGraphDispSetting] = React.useState<GraphDispSetting>({
    xMin: 0,
    xMax: 100,
    yMin: 0,
    yMax: 0,
    selectAxis: 'r',
    isPileup: false,
    isThreshold1: false,
    isThreshold2: false,
    isThreshold3: false,

    isShow1: true,
    isShow2: true,
    isShow3: true,
    unitSelectIndex: 1,
  });

  //ユニット表示選択情報
  const [selectUnit, setSelectUnit] = React.useState<boolean[]>([true, false, false]);

  //メッセージダイアログ
  const [messageDialogOpen, setMessageDialogOpen] = React.useState(false);
  const [showMessage, setShowMessage] = React.useState<string>('');

  const [rangeSelectData, setRangeSelectData] = React.useState<RangeSelectDataType>({
    rengeMin: 0,
    rengeMax: 100,
    rengeId: -1,
    dbId: 0,
    dbMin: -80,
    dbMax: 0,
    selectAxis: 'r',
    yMin: 0,
    yMax: 100,
    holdLinearValueMin: 0,
    holdLinearValueMax: 0,
    yUnit: 'A',
  });

  useEffect(() => {
    console.debug(['change --graphDispSetting-- ', graphDispSetting]);
  }, [graphDispSetting]);

  useEffect(() => {
    let mesRet: MeasureInfoType[] = [];
    let kindNoNameSet: KIND_NO_NAME_SET[] = [];
    let conanFFTTypList: ComboBoxItemType[] = [];
    GetMeasureInfoType()
      .then((res) => {
        //console.debug(['★res', res]);
        mesRet = res;
        //CollectSettingDefine.tsからKIND_NO_NAME_SETをとってくる
        return GetKindNoNameSetType();
      })
      .then((res) => {
        kindNoNameSet = res;
        conanFFTTypList.push({ index: -1, name: '' });
        //FFT(コナン)で必要ない項目は省く
        kindNoNameSet.forEach((r) => {
          if (r.SPEED === SpeedKind.SPEED_CONAN && r.FFT_INVALID === 0) {
            conanFFTTypList.push({ index: r.NAME_NO, name: r.MES_NAME });
          }
        });

        //コレクションを使ってComboBoxにする
        setConanFFTComboList(conanFFTTypList);

        //データリストに特殊データを追加して返す
        mesRet = GetAdditionalMeasureInfoType(t, mesRet);

        //FFT画面では不要な項目を排除
        //mesRet = mesRet.filter((r) => r.FftInvalid === 0);
        //console.debug(['★mesRet1', mesRet]);
        mesRet = mesRet.filter((r) => r.Speed === SpeedKind.SPEED_CONAN);
        console.debug(['★mesRet2', mesRet]);
        //選択データ初期化　3本分
        var sList: SelectDataType[] = [
          CreateDefalutSelectDataType(t('FFTComparisonConanairPage.計測データ１', '計測データ１'), 'red', 1),
          CreateDefalutSelectDataType(t('FFTComparisonConanairPage.計測データ２', '計測データ２'), 'blue', 2),
          CreateDefalutSelectDataType(t('FFTComparisonConanairPage.計測データ３', '計測データ３'), 'green', 3),
        ];

        if (props.location.state != null) {
          var gp = props.location.state;

          console.debug(['props.location.state'], props.location.state);
          //わたってきたデータアイテムを計測リストより検索して格納　3本分
          var dtList: (MeasureInfoType | undefined)[] = [
            FindMeasureInfoType(mesRet, gp, 1),
            FindMeasureInfoType(mesRet, gp, 2),
            FindMeasureInfoType(mesRet, gp, 3),
          ];
          console.debug(['★★trace dtList', dtList]);

          //特殊情報の特定データ作成（振動速度、振動変位用）　3本分
          var compartionList: string[] = [
            GetComparisonNo(dtList[0]),
            GetComparisonNo(dtList[1]),
            GetComparisonNo(dtList[2]),
          ];

          //選択データに計測情報を反映　3本分
          sList.map((row, index) => {
            row = createSelectData(mesRet, row, index + 1, dtList[index], gp);
          });

          //console.debug(['trace', gp, mesRet]);
          if (gp.Time_No1 !== undefined) {
            //console.debug(['trace 1', gp.Time_No1]);
            //わたってきたデータに日付指定がある場合
            const gpTimeList: string[] = [gp.Time_No1, gp.Time_No2, gp.Time_No3];
            sList.map((row, index) => {
              row.selectDate = gpTimeList[index] == '' ? new Date() : dayjs(gpTimeList[index]).toDate();
            });

            if (gp.Time_No1.length > 'yyyy-mm-dd'.length) {
              //console.debug(['trace 2', gp.Time_No1.length, 'yyyy-mm-dd'.length]);
              //わたってきたデータに時間指定がある場合
              sList.map((row, index) => {
                row.selectTime = dayjs(gpTimeList[index]).format('HH:mm:ss');
              });
              console.debug(['s1,s2,s3', sList]);
              setMeasereInfo(mesRet);
              setSelectItemRefreshDatas([
                { mesInfoList: mesRet, selectData: sList[0], fftConanComboBoxList: conanFFTTypList },
                { mesInfoList: mesRet, selectData: sList[1], fftConanComboBoxList: conanFFTTypList },
                { mesInfoList: mesRet, selectData: sList[2], fftConanComboBoxList: conanFFTTypList },
              ]);
              setChartInfo({ line1: sList[0], line2: sList[1], line3: sList[2], mesList: mesRet, isInitDisp: true });
            } else {
              console.debug(['★★trace 3', dtList]);
              //わたってきたデータが日付指定のみの場合
              Promise.all(
                dtList.map((dtRow, index) =>
                  //指定した日時で最新のファイルがある時間を検索する
                  GetDataTimeList(
                    Number(dtRow?.PlcNo),
                    Number(dtRow?.AiCard),
                    Number(dtRow?.AiCh),
                    gpTimeList[index],
                    compartionList[index],
                    sList[index].envelopeNo,
                    sList[index].mesid
                  )
                )
              ).then((ret) => {
                var msg = '';
                //console.debug(['trace 4 sList', sList, 'ret', ret]);
                sList.map((row, index) => {
                  //console.debug(['trace 4-1 index', index]);
                  var retTimes: string[] = ret[index] ?? [];
                  //console.debug(['trace 4-2 retTimes', retTimes]);
                  if (retTimes.length !== 0) {
                    row.selectTime = dayjs(retTimes[0]).format('HH:mm:ss');
                  } else {
                    //指定した日時で時間ファイルが存在しない　ダイアログ表示
                    console.debug(['trace 4-3 error! retTimes', retTimes]);
                    msg +=
                      t('FFTComparisonConanairPage.表示データが存在しません。', '表示データが存在しません。') +
                      ' ' +
                      dtList[index]?.MesName +
                      ' ' +
                      dtList[index]?.DevNo +
                      ' ' +
                      dtList[index]?.DevName +
                      ' ' +
                      dtList[index]?.ItemName +
                      ' ' +
                      gpTimeList[index] +
                      ' /n';
                  }
                });

                if (msg !== '') {
                  setShowMessage(msg);
                  setMessageDialogOpen(true);
                }
                console.debug(['s1,s2,s3', sList]);
                setMeasereInfo(mesRet);
                setSelectItemRefreshDatas([
                  { mesInfoList: mesRet, selectData: sList[0], fftConanComboBoxList: conanFFTTypList },
                  { mesInfoList: mesRet, selectData: sList[1], fftConanComboBoxList: conanFFTTypList },
                  { mesInfoList: mesRet, selectData: sList[2], fftConanComboBoxList: conanFFTTypList },
                ]);
                setChartInfo({ line1: sList[0], line2: sList[1], line3: sList[2], mesList: mesRet, isInitDisp: true });
              });
            }
          } else {
            //console.debug(['trace -- gp.Time_No1 == undefined']);
            Promise.all(
              dtList.map((dtRow, index) =>
                //最新のファイルがある時間を検索する
                GetLatesTime(
                  sList[index].envelopeNo,
                  sList[index].mesid,
                  dtRow?.PlcNo,
                  dtRow?.AiCard,
                  dtRow?.AiCh,
                  compartionList[index]
                )
              )
            ).then((ret) => {
              //console.debug(['GetLatesTime', ret]);

              //最新のファイルがある時間を検索する
              sList.map((row, index) => {
                //console.debug(['GetLatesTime - row', ret[index]]);
                if (dayjs(new Date(ret[index])).format('YYYY-MM-DD') === '1-01-01') {
                  row.selectDate = new Date();
                  row.selectTime = '';
                } else {
                  row.selectDate = new Date(ret[index]);
                  row.selectTime = dayjs(new Date(ret[index])).format('HH:mm:ss');
                }
              });
              console.debug(['s1,s2,s3', sList]);
              setMeasereInfo(mesRet);
              setSelectItemRefreshDatas([
                { mesInfoList: mesRet, selectData: sList[0], fftConanComboBoxList: conanFFTTypList },
                { mesInfoList: mesRet, selectData: sList[1], fftConanComboBoxList: conanFFTTypList },
                { mesInfoList: mesRet, selectData: sList[2], fftConanComboBoxList: conanFFTTypList },
              ]);
              setChartInfo({ line1: sList[0], line2: sList[1], line3: sList[2], mesList: mesRet, isInitDisp: true });
            });
          }
        }
      })
      .then((ret) => { })
      .catch((reason) => { });
  }, [props.location.state]);

  /**
   * 選択データ変更event　画面再描画無し
   * @param value
   * @param dataNo
   */
  const onChangeSelectData = (value: SelectDataType, dataNo: number) => {
    switch (dataNo) {
      case 1:
        console.debug(['onChangeSelectData - old,new', selectData1Ref.current, value]);
        selectData1Ref.current = { ...value };
        break;
      case 2:
        console.debug(['onChangeSelectData - old,new', selectData2Ref.current, value]);
        selectData2Ref.current = { ...value };
        break;
      case 3:
        console.debug(['onChangeSelectData - old,new', selectData3Ref.current, value]);
        selectData3Ref.current = { ...value };
        break;
      default:
    }
  };

  /**
   * グラフに表示する単位情報を選択によって切り替える
   * @param no 計測情報コントロール番号
   */
  const unitSelectClickAction = (no: number) => {
    switch (no) {
      case 1:
        setSelectUnit([true, false, false]);
        SetGraphDispSetting({ ...graphDispSetting, unitSelectIndex: 1 });
        break;
      case 2:
        setSelectUnit([false, true, false]);
        SetGraphDispSetting({ ...graphDispSetting, unitSelectIndex: 2 });
        break;
      case 3:
        setSelectUnit([false, false, true]);
        SetGraphDispSetting({ ...graphDispSetting, unitSelectIndex: 3 });
        break;
    }
  };

  /**
   * 選択データ変更event　画面再描画
   * @param value
   * @param dataNo
   */
  const onChangeSelectDataUpdate = (value: SelectDataType, dataNo: number) => {
    onChangeSelectData(value, dataNo);
    console.debug(['onChangeSelectDataUpdate']);
    switch (dataNo) {
      case 1:
        SetGraphDispSetting({ ...graphDispSetting, isThreshold1: value.isThreshold, isShow1: value.isShow });
        break;
      case 2:
        SetGraphDispSetting({ ...graphDispSetting, isThreshold2: value.isThreshold, isShow2: value.isShow });
        break;
      case 3:
        SetGraphDispSetting({ ...graphDispSetting, isThreshold3: value.isThreshold, isShow3: value.isShow });
        break;
      default:
    }
  };

  const handleGraphDataChange = (datas: GraphData[], yMin: number, yMax: number, yUnit: string) => {
    console.debug(['datas,yMax,yMin,yUnit', datas, yMax, yMin, yUnit]);
    setRangeSelectData({ ...rangeSelectData, yMin: yMin, yMax: yMax, yUnit: yUnit });
    graphDispSetting.yMax = yMax;
    graphDispSetting.yMin = yMin;
    setGraphData({ ...datas });
  };

  //表示ボタン押下
  const handleChartUpDate = () => {
    setLoading(true);
    setChartInfo({
      line1: selectData1Ref.current,
      line2: selectData2Ref.current,
      line3: selectData3Ref.current,
      mesList: measureInfo,
      isInitDisp: false,
    });
  };

  /**
   * レンジ設定変更event
   * @param data
   */
  const handleRengeSelectDataChange = (data: RangeSelectDataType) => {
    console.debug(['tyousa FFTComparisonConanairPage handleRengeSelectDataChange()', data]);

    setLoading(true);

    rangeSelectData.rengeMin = data.rengeMin;
    rangeSelectData.rengeMax = data.rengeMax;
    rangeSelectData.rengeId = data.rengeId;
    rangeSelectData.dbId = data.dbId;
    rangeSelectData.dbMin = data.dbMin;
    rangeSelectData.dbMax = data.dbMax;
    if (rangeSelectData.selectAxis !== data.selectAxis && rangeSelectData.selectAxis === 'r') {
      //リニアからdbに変わったときはセットします
      rangeSelectData.holdLinearValueMin = data.yMin;
      rangeSelectData.holdLinearValueMax = data.yMax;
      rangeSelectData.yMin = data.yMin;
      rangeSelectData.yMax = data.yMax;
    } else if (rangeSelectData.selectAxis !== data.selectAxis && rangeSelectData.selectAxis === 'd') {
      //dbからリニアに変わったときは保持しているデータの入れ替え
      data.yMin = rangeSelectData.holdLinearValueMin;
      data.yMax = rangeSelectData.holdLinearValueMax;
      rangeSelectData.yMin = data.yMin;
      rangeSelectData.yMax = data.yMax;
    } else {
      //ラジオボタンを変えていないときの処理
      rangeSelectData.yMin = data.yMin;
      rangeSelectData.yMax = data.yMax;
    }
    rangeSelectData.selectAxis = data.selectAxis;

    SetGraphDispSetting({
      ...graphDispSetting,
      selectAxis: data.selectAxis,
      xMin: data.rengeMin,
      xMax: data.rengeMax,
      yMin: data.selectAxis === 'r' ? data.yMin : data.dbMin,
      yMax: data.selectAxis === 'r' ? data.yMax : data.dbMax,
    });
  };

  const handleLoadingStateChange = (value: boolean): void => {
    //console.debug('tyousa FFTComparisonPage handleLoadingStateChange()', value);
    setLoading(value);
  };

  const handoleAutoRangeSet = (data: boolean) => {
    isFFTAutoRangeRef.current = data;
  };

  const chartControlMemo = useMemo(() => {
    return (
      <FFTComparisonConanairChart
        chartContainerStyle={classes.responsiveContainer}
        graphDispSetting={graphDispSetting}
        chartInfo={chartInfo}
        onChangeGraphDataEvent={handleGraphDataChange}
        updateLoadginState={handleLoadingStateChange}
        isFFTAutoRangeRef={isFFTAutoRangeRef.current}
        onFFTAutoRamgeSet={handoleAutoRangeSet}
      />
    );
  }, [graphDispSetting, chartInfo]);

  /**
   * ライン番号と一致するグラフデータを返す
   * @param lineNo
   * @returns
   */
  const getGraphData = (lineNo: number): GraphData | undefined => {
    if (graphData) {
      const arr = [graphData[0], graphData[1], graphData[2]];
      let tmp = arr.find((r) => r?.lineNo === lineNo);
      return tmp;
    } else {
      return undefined;
    }
  };
  return (
    <div>
      <Box display="flex" justifyContent="flex-start" alignItems="center">
        <div style={{ width: 10 }}></div>{' '}
        <Paper className={classes.paperChild}>
          <FFTComparisonConanairInfo
            refreshData={selectItemRefreshDatas[0]}
            selectData={selectData1Ref.current}
            measurementName={t('FFTComparisonConanairPage.計測データ１', '計測データ１')}
            graphData={getGraphData(1)}
            onChangeSelectDataEvent={(e) => onChangeSelectData(e, 1)}
            onChangeSelectDataDispUpDateEvent={(e) => onChangeSelectDataUpdate(e, 1)}
            isBlankSelect={false}
            isUnitSelect={selectUnit[0]}
            onClickUnitSelect={() => unitSelectClickAction(1)}
            onAutoRangeSet={handoleAutoRangeSet}
          />
        </Paper>
        <div style={{ width: 10 }}></div>{' '}
        <Paper className={classes.paperChild}>
          <FFTComparisonConanairInfo
            refreshData={selectItemRefreshDatas[1]}
            selectData={selectData2Ref.current}
            measurementName={t('FFTComparisonConanairPage.計測データ２', '計測データ２')}
            graphData={getGraphData(2)}
            onChangeSelectDataEvent={(e) => onChangeSelectData(e, 2)}
            onChangeSelectDataDispUpDateEvent={(e) => onChangeSelectDataUpdate(e, 2)}
            isBlankSelect={true}
            isUnitSelect={selectUnit[1]}
            onClickUnitSelect={() => unitSelectClickAction(2)}
            onAutoRangeSet={handoleAutoRangeSet}
          />
        </Paper>
        <div style={{ width: 10 }}></div>{' '}
        <Paper className={classes.paperChild}>
          <FFTComparisonConanairInfo
            refreshData={selectItemRefreshDatas[2]}
            selectData={selectData3Ref.current}
            measurementName={t('FFTComparisonConanairPage.計測データ３', '計測データ３')}
            graphData={getGraphData(3)}
            onChangeSelectDataEvent={(e) => onChangeSelectData(e, 3)}
            onChangeSelectDataDispUpDateEvent={(e) => onChangeSelectDataUpdate(e, 3)}
            isBlankSelect={true}
            isUnitSelect={selectUnit[2]}
            onClickUnitSelect={() => unitSelectClickAction(3)}
            onAutoRangeSet={handoleAutoRangeSet}
          />
        </Paper>
        <table>
          <tr>
            <FFTComparisonConanairChartSetting
              rangeSelectData={rangeSelectData}
              onChangeRangeSelectDataEvent={handleRengeSelectDataChange}
            />
          </tr>
          <tr>
            <td align="right">
              <LoadingButton
                className={classes.buttonStyle}
                loading={loading}
                loadingPosition="start"
                variant="contained"
                color="primary"
                startIcon={<SearchIcon />}
                onClick={handleChartUpDate}
              >
                {t('FFTComparisonConanairPage.表示', '表示')}
              </LoadingButton>
            </td>
          </tr>
        </table>
      </Box>

      <Grid container justify="flex-start" spacing={1} direction="row" alignItems="center" style={{ margin: 0 }}>
        <Grid item xs={12}>
          {chartControlMemo}
        </Grid>
        <Grid item xs={12}>
          <FFTComparisonConanairButtonList
            measureInfo={measureInfo}
            getSelectDatas={() => {
              return [selectData1Ref.current, selectData2Ref.current, selectData3Ref.current];
            }}
          ></FFTComparisonConanairButtonList>
        </Grid>
      </Grid>
      {/* エラーダイアログ */}
      <SimpleDialog
        open={messageDialogOpen}
        onClose={() => setMessageDialogOpen(false)}
        title={t('FFTComparisonConanairPage.確認', '確認')}
        okText={'OK'}
        maxWidth={'sm'}
      >
        {showMessage.split('/n').map((r) => {
          return <div>{r}</div>;
        })}
      </SimpleDialog>
    </div>
  );
};

export default FFTComparisonConanairPage;
